import { gql } from '@apollo/client'

export const GET_ASSET_TYPES = gql`
    query getAssetTypes {
        assetTypes: master_assetType {
            label
            canBeMonitored
        }
    }
`

export const GET_ASSET_CRITICALITY = gql`
    query getAssetCriticality {
        assetCriticality: master_assetCriticality {
            color
            label
        }
    }
`

export const GET_ORG_ASSETS = gql`
    query getOrgAssets {
        assets: assets_asset {
            assetCriticalityLabel
            assetTypeLabel
            id
            label
        }
    }
`
export const GET_ORG_ASSETS_BY_ASSET_TYPE = gql`
    query GET_ORG_ASSETS_BY_ASSET_TYPE(
        $assetsWhere: assets_asset_bool_exp
        $monitoredAssetWhere: assets_asset_bool_exp
        $orderBy: [assets_asset_order_by!] = { created_at: desc_nulls_last }
        $limit: Int! = 10
        $offset: Int! = 0
    ) {
        assets: assets_asset(
            where: $assetsWhere
            order_by: $orderBy
            limit: $limit
            offset: $offset
        ) {
            assetCriticalityLabel
            assetTypeLabel
            id
            label
            is_monitored
            isAgentActive
            agentDetails
            agentName
            assetMetaDetails
            ipDetails
            description
            operatingSystem
            tags
            incidents_aggregate {
                aggregate {
                    count
                }
            }
            totalResolvedLinkedIncident: incidents_aggregate(
                where: { incident: { isResolved: { _eq: true } } }
            ) {
                aggregate {
                    count
                }
            }
            totalAlerts
            totalEvents
        }
        assetAggregate: assets_asset_aggregate(where: $assetsWhere) {
            aggregate {
                count
            }
        }
        totalMonitoredAssets: assets_asset_aggregate(
            where: $monitoredAssetWhere
        ) {
            aggregate {
                count
            }
        }
    }
`

export const GET_ASSET_TAGS = gql`
    query getAssetTags {
        assets_get_tags {
            tags
        }
    }
`
export const GET_AGENT_GUIDE_ASSET = gql`
    query GET_AGENT_GUIDE_ASSET($assetId: String!) {
        agentGuide: assets_asset_by_pk(id: $assetId) {
            id
            label
            is_monitored
            isAgentActive
            agentName
            agentDetails
            organization {
                id
            }
        }
    }
`

export const GET_USER_DETAILS_FOR_CONTEXT = gql`
    query GET_USER_DETAILS_FOR_CONTEXT($email: String!) {
        features: master_featureFlags(where: { enabled: { _eq: true } }) {
            feature
            enabled
        }
        users: users_user(where: { email: { _eq: $email } }) {
            email
            firstName
            lastName
            phoneNumber
            attachments
            isAdministrator
            auth0UserId
            id
            created_at
            organizationId
            lastSeenNotificationId
            organization {
                id
                creditAmount
                timezone
                legalName
                created_at
                attachments
                isRevoked
                billingEmail
                billingAddress
            }
            workRoles {
                workRoleLabel
                workRoleId
                workRole {
                    permissions
                    organization_workroles {
                        permissions
                    }
                }
            }
        }
    }
`

export const GET_ORG_METADATA = gql`
    query GET_ORG_METADATA {
        orgSizes: master_orgSize {
            id: sizeId
            value: sizeValue
            label: sizeValue
        }
        orgIndustries: master_orgIndustry {
            id: industryId
            value: industryValue
            label: industryValue
        }
    }
`

export const GET_WORK_ROLES = gql`
    query getWorkRoles($params: jsonb!) {
        workRoles: master_workRole {
            id
            label
            metaDescription {
                contentBody
                heading
            }
            isActiveWorkRole(args: { params: $params })
            type
        }
    }
`

export const GET_INCIDENT_TEMPLATE_BY_ORG = gql`
    query GET_INCIDENT_TEMPLATE_BY_ORG($incidentTypeId: String! = "") {
        incidentType: incidents_incidentType_by_pk(id: $incidentTypeId) {
            incidentTemplateByOrganizations {
                incidentTemplate
                organizationId
            }
            id
            defaultTemplate: template
            label
            organizationId
            metaDescriptionId
            metaDescription {
                contentBody
            }
        }
    }
`

export const GET_INCIDENT_TYPES_BY_ORG = gql`
    query getIncidentTypeTemplate {
        incidentTypes: incidents_incidentType {
            id
            label
        }
    }
`
export const GET_INCIDENT_LIST = gql`
    query GET_INCIDENT_LIST(
        $where: incidents_incident_bool_exp
        $limit: Int! = 10
        $offset: Int! = 0
        $orderBy: [incidents_incident_order_by!] = { created_at: desc }
    ) {
        incidents: incidents_incident(
            where: $where
            order_by: $orderBy
            offset: $offset
            limit: $limit
        ) {
            type
            id
            assets {
                assetId
                asset {
                    label
                    assetCriticalityLabel
                    tags
                }
            }
            detectedBy
            cirtLeaderUser {
                id
                firstName
                lastName
                attachments
            }
            isResolved
            resolvedAt
            displayId
            displayName
            created_at
            occuredOn
            incidentSeverity
            activeTaskBoardDetails
            simulationKpis {
                metric_name: kpiType
                value
            }
            simulationParam {
                parameters
            }
        }
        totalIncidents: incidents_incident_aggregate(where: $where) {
            aggregate {
                count
            }
        }
    }
`

export const GET_INCIDENT_LIST_FOR_REPORTS = gql`
    query GET_INCIDENT_LIST_FOR_REPORTS(
        $where: incidents_incident_bool_exp
        $limit: Int! = 10
        $offset: Int! = 0
        $orderBy: [incidents_incident_order_by!] = { created_at: desc }
    ) {
        incidents: incidents_incident(
            where: $where
            order_by: $orderBy
            offset: $offset
            limit: $limit
        ) {
            displayName
            type
            id
            assets {
                assetId
                asset {
                    label
                    assetCriticalityLabel
                }
            }
            detectedBy
            cirtLeaderUser {
                firstName
                lastName
                attachments
                id
            }
            displayId
            reportPassword
            isResolved
            occuredOn
            occuredOnYear
            incidentSeverity
            activeTaskBoardDetails
            resolvedAt
            simulationParam {
                parameters
            }
        }
        totalIncidents: incidents_incident_aggregate(where: $where) {
            aggregate {
                count
            }
        }
    }
`
export const GET_USER_WORK_ROLE_LOGS = gql`
    query getUserWorkRoleLogs($userId: String! = "") {
        userWorkRoleLogs: users_user_by_pk(id: $userId) {
            userRoleLogs
        }
    }
`

export const GET_INCIDENT_HISTORY_LOGS = gql`
    query getIncidentHistoryLogs($incidentId: String! = "") {
        incidentHistory: history_incidents(
            where: { incidentId: { _eq: $incidentId } }
            order_by: { createdAt: asc_nulls_first }
        ) {
            actionType
            addedByUser {
                firstName
                lastName
            }
            updatedByUser {
                email
                firstName
                lastName
            }
            id
            createdAt
            newValues
        }
    }
`

export const GET_TASK_HISTORY_LOGS = gql`
    query getTaskHistory($incidentId: String = "", $taskId: String = "") {
        taskHistory: history_tasks(
            where: {
                incidentId: { _eq: $incidentId }
                taskId: { _eq: $taskId }
            }
            order_by: { createdAt: asc_nulls_first }
        ) {
            id
            newValues
            actionType
            updatedByUser {
                firstName
                lastName
            }
            createdAt
        }
    }
`

export const GET_USER_NAMES = gql`
    query GET_USER_NAMES {
        userNames: users_user {
            id
            firstName
            lastName
        }
    }
`

export const GET_ASSET_HISTORY_LOGS = gql`
    query getAssetHistoryLogs($assetId: String! = "") {
        assetHistory: history_assets(
            where: { assetId: { _eq: $assetId } }
            order_by: { createdAt: asc_nulls_first }
        ) {
            assetId
            createdAt
            newValues
            id
            actionType
            updatedByUser {
                firstName
                lastName
            }
        }
    }
`

export const GET_USER_INFO_HISTORY_LOGS = gql`
    query getUserInfoHistoryLogs($userId: String! = "") {
        userInfoHistory: history_users(
            where: { userId: { _eq: $userId } }
            order_by: { createdAt: asc_nulls_first }
        ) {
            createdAt
            id
            newValues
            actionType
            updatedByUser {
                firstName
                lastName
            }
        }
    }
`

export const GET_ORG_INFO_HISTORY_LOGS = gql`
    query getOrgInfoHistory($orgId: String! = "") {
        orgInfoHistory: history_organizations(
            where: { organizationId: { _eq: $orgId } }
            order_by: { createdAt: asc_nulls_first }
        ) {
            updatedByUser {
                firstName
                lastName
            }
            actionType
            newValues
            id
            createdAt
        }
    }
`

export const GET_RISK_MANAGEMENT_CATEGORY_DATA = gql`
    subscription getRiskMangementCategoryData($categoryId: String! = "") {
        categoryData: riskManagement_rmLogCategory_by_pk(id: $categoryId) {
            description
            label
            questions(
                order_by: { position: asc_nulls_first }
                where: { parentRmLogQuestionId: { _is_null: true } }
            ) {
                id
                identifier
                label
                identifier
                parentRmLogQuestionId
                childQuestions(order_by: { position: asc_nulls_first }) {
                    id
                    label
                    position
                    parentRmLogQuestionId
                    identifier
                    description
                    renderType
                    selectedOption
                    score
                    options
                }
                options
                position
                renderType
                selectedOption
            }
        }
    }
`

export const GET_RISK_MANAGEMENT_TEMPLATE = gql`
    query getRiskManagementTemplate($id: String! = "") {
        template: riskManagement_riskManagementTemplate_by_pk(id: $id) {
            frameworkName
            id
            template
        }
    }
`

export const GET_QUESTIONS_FROM_CATEGORY_ID = gql`
    query getQuestionIdsFromCategoryId($categoryId: String! = "") {
        questionIds: riskManagement_rmLogCategory_by_pk(id: $categoryId) {
            questions {
                id
            }
        }
    }
`
export const RISK_RECOMMENDED_ACTION_ITEMS = gql`
    subscription MySubscription(
        $where: riskManagement_rmLogQuestion_bool_exp!
    ) {
        riskManagement_rmLogQuestion(where: $where) {
            id
            options
            position
            selectedOption
            category {
                label
            }
        }
    }
`
export const ACTION_ITEMS_CATEGORY_LIST = gql`
    query actionItemsCategoryList {
        riskManagement_rmLogCategory(distinct_on: label) {
            id
            label
        }
    }
`
export const GET_CIRT_LEADER_USERS = gql`
    query MyQuery {
        users: users_user(
            where: {
                workRoles: { workRole: { label: { _eq: "CIRT Leader" } } }
            }
            order_by: {
                userTimeAvailabilities_aggregate: {
                    sum: { totalHours: desc_nulls_last }
                }
            }
        ) {
            email
            firstName
            phoneNumber
            id
            attachments
            incidentsViewAsCirtLeader_aggregate(
                where: { activeStage: { _neq: "Lessons Learned" } }
            ) {
                aggregate {
                    count(columns: id)
                }
            }
            userTimeAvailabilities_aggregate {
                aggregate {
                    sum {
                        totalHours
                    }
                }
            }
        }
    }
`
export const ALERT_DETAILS_TOOLTIP_DESCRIPTION = gql`
    query ALERT_DETAILS_TOOLTIP_DESCRIPTION(
        $urgencyLabel: String!
        $impactLabel: String!
    ) {
        master_incidentImpact(where: { label: { _eq: $impactLabel } }) {
            color
            description
            label
            severity
        }
        master_incidentUrgency(where: { label: { _eq: $urgencyLabel } }) {
            color
            description
            label
            severity
        }
    }
`
export const GET_ORG_STRIPE_CUSTOMER_ID = gql`
    query stripeCustomerId {
        users_organization {
            stripeCustomerId
        }
    }
`
export const GET_PAYMENT_METHOD = {
    AGGREGATE: gql`
        query paymentMethodCount {
            totalCount: payments_paymentMethod_aggregate {
                aggregate {
                    count
                }
            }
        }
    `,
    LIST: gql`
        query paymentMethods {
            paymentMethodDetails: payments_paymentMethod {
                brand
                cardholderName
                cvcCheck
                expMonth
                expYear
                funding
                id
                last4digits
                stripePaymentMethodId
                stripeCustomerId
                organizationId
            }
        }
    `,
}

export const GET_ORG_DETAILS = gql`
    query GET_ORG_DETAILS {
        users_organization {
            id
            defaultStripePaymentMethodId
            stripeCustomerId
            currentInvoiceDetails
            billingEmail
            billingAddress
            creditAmount
            size
            org_size_id
        }
    }
`

export const GET_INCIDENT_PLAYBOOK_DATA = gql`
    query GET_INCIDENT_PLAYBOOK_DATA($incidentId: String!) {
        incident: incidents_incident_by_pk(id: $incidentId) {
            incidentType {
                id
                template
                incidentTemplateByOrganizations {
                    organizationId
                    incidentTypeId
                    template: incidentTemplate
                }
            }
        }
    }
`

export const GET_ALERTNATE_WORKROLES = gql`
    query GET_ALTERNATE_WORKROLES($id: String!) {
        master_workRole(
            where: { id: { _neq: $id } }
            order_by: { organizationId: desc_nulls_first }
        ) {
            id
            label
            type
            organizationId
        }
    }
`

export const CHECK_ROLE_LABEL_EXISTS = gql`
    query CHECK_LABEL_EXISTS($label: String!) {
        workRoles: master_workRole(where: { label: { _ilike: $label } }) {
            id
            label
        }
    }
`
export const INCIDENT_COUNT_WITH_ARTIFACTS = gql`
    query INCIDENT_COUNT_WITH_ARTIFACTS {
        totalIncidentsWithArtifacts: tasks_taskArtifact_aggregate {
            aggregate {
                count(distinct: true, columns: incidentId)
            }
        }
        totalIncidents: incidents_incident_aggregate {
            aggregate {
                count
            }
        }
    }
`
export const GET_TASK_ARTIFACTS = gql`
    query GET_TASK_ARTIFACTS($artifactsWhere: tasks_taskArtifact_bool_exp!) {
        artifactList: tasks_taskArtifact_aggregate(where: $artifactsWhere) {
            aggregate {
                count
            }
            nodes {
                id
                taskId
                task {
                    id
                    displayId
                }
                incident {
                    id
                    displayId
                }
                organizationId
                s3Key
                label
                attachmentUrl
                addedBy
                created_at
                updatedBy
                updated_at
            }
        }
    }
`
export const ARTIFACTS_STATISTICS = gql`
    query ARTIFACTS_STATISTICS {
        totalArtifacts: tasks_taskArtifact_aggregate(
            where: { archived: { _eq: false } }
        ) {
            aggregate {
                count
            }
        }
        totalTasksWithArtifacts: tasks_taskArtifact_aggregate(
            where: { archived: { _eq: false } }
        ) {
            aggregate {
                count(distinct: true, columns: taskId)
            }
        }
        totalTasks: tasks_task_aggregate {
            aggregate {
                count
            }
        }
        totalIncidentsWithArtifacts: tasks_taskArtifact_aggregate(
            where: { archived: { _eq: false } }
        ) {
            aggregate {
                count(distinct: true, columns: incidentId)
            }
        }
        totalIncidents: incidents_incident_aggregate {
            aggregate {
                count
            }
        }
    }
`
export const GET_USERS_WITH_FILTER = gql`
    query getUsersWithFilter($where: users_user_bool_exp = {}) {
        users: users_user(where: $where) {
            id
            email
            firstName
            lastName
            phoneNumber
            hasAcceptedInvite
            resendInviteAttempt
            isAdministrator
            attachments
            organization {
                attachments
            }
            isActive
            invitationExpiresAt
            workRoles {
                workRole {
                    label
                }
            }
        }
    }
`

export const CHECK_ALERT_GROUP_NAME_EXISTS_ALL = gql`
    query CHECK_ALERT_GROUP_NAME_EXISTS_ALL($groupName: String!) {
        groups: alerts_alertGroup(where: { label: { _ilike: $groupName } }) {
            id
        }
    }
`

export const CHECK_ALERT_GROUP_NAME_EXISTS = gql`
    query CHECK_ALERT_GROUP_NAME_EXISTS(
        $groupName: String!
        $groupId: String!
    ) {
        groups: alerts_alertGroup(
            where: {
                _and: { id: { _neq: $groupId }, label: { _ilike: $groupName } }
            }
        ) {
            id
        }
    }
`

export const CHECK_ALERT_DISPOSITION_EXISTS = gql`
    query CHECK_ALERT_DISPOSITION_EXISTS($dispositionLabel: String!) {
        alertDispositions: master_alert_disposition(
            where: {
                _or: [
                    {
                        organizationId: { _is_null: true }
                        label: { _ilike: $dispositionLabel }
                    }
                    {
                        organizationId: { _is_null: false }
                        label: { _ilike: $dispositionLabel }
                    }
                ]
            }
        ) {
            id
            organizationId
            label
        }
    }
`

export const DISPOSITION_ALERT_COUNTS_BY_GROUPID = gql`
    query DISPOSITION_ALERT_COUNTS_BY_GROUPID($groupId: String!) {
        dispositions: master_alert_disposition {
            id
            label
            alerts: alerts_aggregate(where: { groupId: { _eq: $groupId } }) {
                aggregate {
                    count
                }
            }
        }
    }
`

export const GET_ALERT_GROUPS_WITH_STATS = gql`
    query GET_ALERT_GROUPS_WITH_STATS(
        $groupsWhere: alerts_alertGroup_bool_exp
        $orderBy: [alerts_alertGroup_order_by!] = { created_at: desc }
        $groupsLimit: Int = 15
        $groupsOffset: Int = 0
        $_24hours: timestamptz!
        $_7days: timestamptz!
        $_30days: timestamptz!
        $alertRange: timestamptz_comparison_exp
    ) {
        alertGroups: alerts_alertGroup(
            where: $groupsWhere
            order_by: $orderBy
            limit: $groupsLimit
            offset: $groupsOffset
        ) {
            id
            label
            description
            created_at
            corelatedBy
            alertsAllTime: alerts_hp_aggregate {
                aggregate {
                    count
                }
            }
            alerts24Hours: alerts_hp_aggregate(
                where: {
                    _and: [
                        { alertTimestamp: $alertRange }
                        { alertTimestamp: { _gt: $_24hours } }
                    ]
                }
            ) {
                aggregate {
                    count
                }
            }
            alerts7Days: alerts_hp_aggregate(
                where: {
                    _and: [
                        { alertTimestamp: $alertRange }
                        { alertTimestamp: { _gt: $_7days } }
                    ]
                }
            ) {
                aggregate {
                    count
                }
            }
            alerts30Days: alerts_hp_aggregate(
                where: {
                    _and: [
                        { alertTimestamp: $alertRange }
                        { alertTimestamp: { _gt: $_30days } }
                    ]
                }
            ) {
                aggregate {
                    count
                }
            }
            createdByUser {
                firstName
                lastName
            }
        }
        totalAlertGroups: alerts_alertGroup_aggregate(where: $groupsWhere) {
            aggregate {
                count
            }
        }
    }
`

export const GET_ALERT_GROUPS_FOR_MODAL = gql`
    query GET_ALERT_GROUPS_FOR_MODAL(
        $groupsWhere: alerts_alertGroup_bool_exp
        $orderBy: [alerts_alertGroup_order_by!] = { created_at: desc }
        $groupsLimit: Int = 15
        $groupsOffset: Int = 0
    ) {
        alertGroups: alerts_alertGroup(
            where: $groupsWhere
            order_by: $orderBy
            limit: $groupsLimit
            offset: $groupsOffset
        ) {
            id
            label
            description
            created_at
            corelatedBy
            alertsAllTime: alerts_hp_aggregate {
                aggregate {
                    count
                }
            }
            createdByUser {
                firstName
                lastName
                fullName @client
            }
        }
        totalAlertGroups: alerts_alertGroup_aggregate(where: $groupsWhere) {
            aggregate {
                count
            }
        }
    }
`

export const FETCH_ASSET_LIST_WITH_STATS = gql`
    query FETCH_ASSET_LIST_WITH_STATS(
        $assetsWhere: assets_asset_bool_exp
        $limit: Int!
        $offset: Int!
        $orderBy: [assets_asset_order_by!] = { created_at: desc }
        $_24hours: timestamptz!
        $_7days: timestamptz!
        $_30days: timestamptz!
        $alertRange: timestamptz_comparison_exp
    ) {
        assets_asset(
            where: $assetsWhere
            limit: $limit
            offset: $offset
            order_by: $orderBy
        ) {
            id
            alertsAllTime: alerts_hp_aggregate {
                aggregate {
                    count
                }
            }
            alerts24Hours: alerts_hp_aggregate(
                where: { alertTimestamp: { _gt: $_24hours } }
            ) {
                aggregate {
                    count
                }
            }
            alerts7Days: alerts_hp_aggregate(
                where: { alertTimestamp: { _gt: $_7days } }
            ) {
                aggregate {
                    count
                }
            }
            alerts30Days: alerts_hp_aggregate(
                where: { alertTimestamp: { _gt: $_30days } }
            ) {
                aggregate {
                    count
                }
            }
            label
            assetTypeLabel
            assetCriticalityLabel
            agentName
            updated_at
            created_at
            is_monitored
            addedByUser {
                firstName
                lastName
            }
        }
        totalAssets: assets_asset_aggregate(where: $assetsWhere) {
            aggregate {
                count
            }
        }
    }
`

export const GET_ALERT_DISPOSITIONS = gql`
    query GET_ALERT_DISPOSITIONS {
        alertDisposition: master_alert_disposition(
            order_by: [
                { organizationId: desc_nulls_first }
                { updated_at: desc }
            ]
        ) {
            id
            label
            description
            isOpen
            organizationId
        }
    }
`
export const GET_ASSET_DETAILS = gql`
    query GET_ASSET_DETAILS(
        $assetId: String = ""
        $alertsWhere: alerts_alert_hp_bool_exp
    ) {
        assetDetails: assets_asset_by_pk(id: $assetId) {
            id
            agentName
            label
            assetTypeLabel
            assetCriticalityLabel
            assetCriticality {
                color
                label
            }
            lastUpdateFromIntegration
            integration_assets_aggregate {
                aggregate {
                    count
                }
                nodes {
                    integration {
                        id
                        label
                    }
                }
            }
            tags
            ipDetails
            description
            operatingSystem
            is_monitored
            isAgentActive
            assetMetaDetails
            updated_at
            updatedByUser {
                firstName
                lastName
            }
        }
        lastAlert: alerts_alert_hp(
            limit: 1
            order_by: { alertTimestamp: desc }
            where: $alertsWhere
        ) {
            id
            alertTimestamp
        }
        totalIncident: incidents_incident_assets_aggregate(
            where: { assetId: { _eq: $assetId } }
        ) {
            aggregate {
                count
            }
        }
        totalResolvedIncident: incidents_incident_assets_aggregate(
            where: {
                assetId: { _eq: $assetId }
                incident: { isResolved: { _eq: true } }
            }
        ) {
            aggregate {
                count
            }
        }
    }
`

// Keep in sync with GET_ASSET_DETAILS (alerts fields removed for production)
export const GET_ASSET_DETAILS_WITHOUT_ALERTS = gql`
    query GET_ASSET_DETAILS_WITHOUT_ALERTS($assetId: String = "") {
        assetDetails: assets_asset_by_pk(id: $assetId) {
            id
            agentName
            label
            assetTypeLabel
            assetCriticalityLabel
            assetCriticality {
                color
                label
            }
            lastUpdateFromIntegration
            integration_assets_aggregate {
                aggregate {
                    count
                }
                nodes {
                    integration {
                        id
                        label
                    }
                }
            }
            tags
            ipDetails
            description
            operatingSystem
            is_monitored
            isAgentActive
            assetMetaDetails
            updated_at
            updatedByUser {
                firstName
                lastName
            }
        }
        totalIncident: incidents_incident_assets_aggregate(
            where: { assetId: { _eq: $assetId } }
        ) {
            aggregate {
                count
            }
        }
        totalResolvedIncident: incidents_incident_assets_aggregate(
            where: {
                assetId: { _eq: $assetId }
                incident: { isResolved: { _eq: true } }
            }
        ) {
            aggregate {
                count
            }
        }
    }
`

export const FETCH_ALERT_INCIDENT = gql`
    query fetchLAlertIncident {
        alerts_alert_incident {
            alertId
            incidentId
        }
    }
`
export const FETCH_ALERT_ASSET = gql`
    query fetchLAlertAssetList($where: alerts_alert_asset_bool_exp = {}) {
        alerts_alert_asset(where: $where) {
            alertId
            assetId
        }
    }
`

export const GET_ALERTS_HP_BY_DISPOSITION = gql`
    query GET_ALERTS_HP_BY_DISPOSITION(
        $limit: Int! = 10
        $alertsWhere: alerts_alert_hp_bool_exp = null
        $offset: Int! = 0
        $orderBy: [alerts_alert_hp_order_by!] = { alertTimestamp: desc }
    ) {
        alerts: alerts_alert_hp(
            where: $alertsWhere
            limit: $limit
            offset: $offset
            order_by: $orderBy
        ) {
            id
            alertTimestamp
            created_at
            ossecRule {
                id
                ruleId
                technique
                tactic
                description
            }
            ruleId
            agent_name
            alert_tactic
            alert_technique
            asset {
                id
                label
                assetTypeLabel
                assetCriticality {
                    color
                    label
                }
            }
            alertCriticality {
                color
            }
            alert_level
            alert_criticality_label
            alertDescription
            isOpen
            status: alert_disposition {
                label
            }
            linkedIncidents: alert_incidents(limit: 1) {
                incident {
                    id
                    displayId
                }
            }
            totalEvents: total_events_in_window(
                args: { time_window: "90days" }
            ) {
                data
            }
            events24Hours: total_events_in_window(
                args: { time_window: "24hours" }
            ) {
                data
            }
            events7Days: total_events_in_window(
                args: { time_window: "7Days" }
            ) {
                data
            }
            events30Days: total_events_in_window(
                args: { time_window: "30Days" }
            ) {
                data
            }
            source
            # TODO get from continuous aggregates
            # totalAlerts: totalEvents
        }
        # TODO check whether this is can be avoided
        totalAlerts: alerts_alert_hp_aggregate(where: $alertsWhere) {
            aggregate {
                count
            }
        }
    }
`

export const FETCH_LICENSE_KEY = gql`
    query licenseKey($orgId: String!) {
        users_organization_by_pk(id: $orgId) {
            licenseKey
        }
    }
`
// TODO ts - check this
export const FETCH_ALERTS_IDS = gql`
    query fetchAlertIds($where: alerts_alert_bool_exp!) {
        alerts_alert(where: $where) {
            id
        }
    }
`

export const CHECK_ALERT_DISPOSITION_EXISTS_ONE = gql`
    query CHECK_ALERT_DISPOSITION_EXISTS_ONE($label: String!, $id: String) {
        alertDispositions: master_alert_disposition(
            where: {
                _and: [{ id: { _neq: $id } }, { label: { _ilike: $label } }]
            }
        ) {
            id
        }
    }
`

export const GET_RULES_PREFERENCE = gql`
    query rulesPreference {
        master_ossecRules_aggregate {
            aggregate {
                count
            }
            nodes {
                type
                technique
                tactic
                ruleId
                metaDetails
                level
                id
                group
                description
                ossecRules_preferences {
                    id
                    ignoreAlerts
                    alertDisposition {
                        id
                        label
                    }
                }
            }
        }
    }
`

export const FETCH_ALERT_DISPOSITION_LIST = gql`
    query fetchAlertDispositionList(
        $where: master_alert_disposition_bool_exp = {}
    ) {
        alertDispositionList: master_alert_disposition(where: $where) {
            id
            label
            isOpen
        }
    }
`

// TODO ts - check this
export const GET_RULES_PREFERENCE_WITH_STATS = gql`
    query rulesPreference(
        $_24hours: bigint!
        $_7days: bigint!
        $_30days: bigint!
        $dispositionExp: [alerts_alert_bool_exp!]
        $alertRange: bigint_comparison_exp
    ) {
        master_ossecRules_aggregate {
            aggregate {
                count
            }
            nodes {
                type
                technique
                tactic
                ruleId
                metaDetails
                level
                id
                group
                description
                alertsAllTime: alerts_aggregate(
                    where: { alertTimestamp: $alertRange, _or: $dispositionExp }
                ) {
                    aggregate {
                        count
                    }
                }
                alerts24Hours: alerts_aggregate(
                    where: {
                        _and: [
                            { alertTimestamp: $alertRange }
                            { alertTimestamp: { _gt: $_24hours } }
                            { _or: $dispositionExp }
                        ]
                    }
                ) {
                    aggregate {
                        count
                    }
                }
                alerts7Days: alerts_aggregate(
                    where: {
                        _and: [
                            { alertTimestamp: $alertRange }
                            { alertTimestamp: { _gt: $_7days } }
                            { _or: $dispositionExp }
                        ]
                    }
                ) {
                    aggregate {
                        count
                    }
                }
                alerts30Days: alerts_aggregate(
                    where: {
                        _and: [
                            { alertTimestamp: $alertRange }
                            { alertTimestamp: { _gt: $_30days } }
                            { _or: $dispositionExp }
                        ]
                    }
                ) {
                    aggregate {
                        count
                    }
                }
            }
        }
    }
`

export const GET_ASSETS_BY_ALERT_DETAILS = gql`
    query GET_ASSETS_BY_ALERT_DETAILS($assetIds: [String!]!) {
        assets: assets_asset(where: { id: { _in: $assetIds } }) {
            id
            label
            assetCriticalityLabel
            assetTypeLabel
        }
    }
`

export const GET_ASSETS_BY_AGENT_NAMES = gql`
    query GET_ASSETS_BY_AGENT_NAMES($agents: [String!]!) {
        assets: assets_asset(where: { agentName: { _in: $agents } }) {
            id
            label
            assetCriticalityLabel
            assetTypeLabel
        }
    }
`

export const GET_RULES_WITH_PAGINATION_HP = gql`
    query GET_RULES_WITH_PAGINATION_HP(
        $_24hours: timestamptz!
        $_7days: timestamptz!
        $_30days: timestamptz!
        $alertRange: timestamptz_comparison_exp
        $limit: Int = 5
        $offset: Int = 0
        $orderBy: [master_ossecRules_order_by!]
        $filter: master_ossecRules_bool_exp!
    ) {
        rules: master_ossecRules(
            limit: $limit
            offset: $offset
            order_by: $orderBy
            where: $filter
        ) {
            type
            technique
            tactic
            ruleId
            metaDetails
            level
            id
            group
            description
            alertsAllTime: alerts_hp_aggregate {
                aggregate {
                    count
                }
            }
            alerts24Hours: alerts_hp_aggregate(
                where: {
                    _and: [
                        { alertTimestamp: $alertRange }
                        { alertTimestamp: { _gt: $_24hours } }
                    ]
                }
            ) {
                aggregate {
                    count
                }
            }
            alerts7Days: alerts_hp_aggregate(
                where: {
                    _and: [
                        { alertTimestamp: $alertRange }
                        { alertTimestamp: { _gt: $_7days } }
                    ]
                }
            ) {
                aggregate {
                    count
                }
            }
            alerts30Days: alerts_hp_aggregate(
                where: {
                    _and: [
                        { alertTimestamp: $alertRange }
                        { alertTimestamp: { _gt: $_30days } }
                    ]
                }
            ) {
                aggregate {
                    count
                }
            }
        }
        totalRules: master_ossecRules_aggregate(where: $filter) {
            aggregate {
                count
            }
        }
    }
`

export const GET_ALERT_DETAILS = gql`
    query GET_ALERT_DETAILS($id: String!) {
        alertDetails: alerts_alert_by_pk(id: $id) {
            id
            hash
            src_ip
            src_port
            dest_ip
            dest_port
            created_at
            alertTimestamp
            event_first_seen
            potentialIncidentSeverity
            potentialIncidentType
            ioc_dict
            additional_details
            incidentType {
                metaDescription {
                    contentBody
                }
            }
            ossecRule {
                alertSignature: description
                alertCategory: group
                alertSummary: metaDetails
                tactic
                technique
            }
            asset {
                id
                label
                agentName
                assetCriticality {
                    label
                }
            }
            alert_incidents {
                incidentId
                alertId
                incident {
                    displayId
                }
            }
            isResolved
        }
    }
`

export const GET_ALERT_HP_DETAILS = gql`
    query GET_ALERT_HP_DETAILS($id: String!) {
        alerts: alerts_alert_hp(where: { id: { _eq: $id } }) {
            id
            hash
            src_ip
            srcip
            src_port
            dest_ip
            dest_port
            created_at
            alertTimestamp
            potentialIncidentImpact
            potentialIncidentUrgency
            potentialIncidentSeverity
            alert_technique
            potentialIncidentSeverity_rel {
                severity
                impact
                urgency
            }
            potentialIncidentType
            source
            alertDescription
            signature
            alertSummary
            additional_details
            ioc_dict
            totalEvents: total_events_in_window(
                args: { time_window: "90days" }
            ) {
                data
            }
            incidentType {
                metaDescription {
                    contentBody
                }
                label
            }
            ossecRule {
                alertSignature: description
                alertCategory: group
                alertSummary: metaDetails
                tactic
                technique
            }
            asset {
                id
                label
                agentName
                assetCriticality {
                    label
                }
            }
            alert_incidents {
                incidentId
                alertId
                incident {
                    displayId
                }
            }
        }
    }
`

export const GET_ASSET_LIST = gql`
    query assetList($where: assets_asset_bool_exp = {}) {
        assets: assets_asset(where: $where) {
            id
            label
            assetTypeLabel
            assetCriticalityLabel
        }
    }
`

export const GET_ALERT_EVENTS = gql`
    query GET_ALERT_EVENT(
        $limit: Int! = 10
        $alertsWhere: alerts_alertEvent_bool_exp
        $offset: Int! = 0
        $orderBy: [alerts_alertEvent_order_by!] = { created_at: desc }
    ) {
        alerts: alerts_alertEvent(
            where: $alertsWhere
            limit: $limit
            offset: $offset
            order_by: $orderBy
        ) {
            id
            agent_name
            alertTimestamp
            alert_tactic
            alert_technique
            asset {
                id
                label
                assetCriticality {
                    color
                    label
                }
            }
            alertCriticality {
                color
            }
            alert_level
            alert_criticality_label
            alertDescription
            isOpen
            status: alertDisposition {
                label
            }
        }
        totalAlerts: alerts_alertEvent_aggregate(where: $alertsWhere) {
            aggregate {
                count
            }
        }
    }
`

export const GET_ALERT_INCIDENT_AGGREGATE = gql`
    query alertIncidentAggregate($incidentId: String!) {
        alertIncidentAggregate: alerts_alert_incident_aggregate(
            where: { incidentId: { _eq: $incidentId } }
        ) {
            aggregate {
                count
            }
        }
    }
`

export const GET_ALERT_EVENT_DETAILS = gql`
    query getAlertEventDetails($id: String!) {
        alert_event: alerts_alertEvent_by_pk(id: $id) {
            id
            agent_ip
            agent_name
            alertTimestamp
            alert_log
            alert_tactic
            alert_technique
            asset {
                id
                label
                assetCriticality {
                    color
                    label
                }
            }
            ossecRule {
                alertSignature: description
                alertCategory: group
                alertSummary: metaDetails
                tactic
                technique
            }
            alertCriticality {
                color
            }
            alert_level
            alert_criticality_label
            alert_source
            alertDescription
            potentialIncidentSeverity
            potentialIncidentImpact
            potentialIncidentUrgency
            potentialIncidentType
            potentialIncidentTypeId
            alertSummary
            dest_ip
            dest_port
            signature
            src_ip
            src_port
            alertCategory
            ioc_dict
            incidentType {
                metaDescription {
                    contentBody
                    assets
                }
            }
        }
    }
`

export const GET_ALERT_DETAILS_ONE = gql`
    query GET_ALERT_DETAILS_ONE($id: String!) {
        alert: alerts_alert_by_pk(id: $id) {
            id
            agent_ip
            agent_name
            alertTimestamp
            alert_log
            alert_tactic
            alert_technique
            asset {
                id
                label
                assetCriticality {
                    color
                    label
                }
            }
            alertCriticality {
                color
            }
            alert_level
            alert_criticality_label
            alert_source
            alertDescription
            potentialIncidentSeverity
            potentialIncidentImpact
            potentialIncidentUrgency
            potentialIncidentType
            potentialIncidentTypeId
            alertSummary
            dest_ip
            dest_port
            signature
            src_ip
            src_port
            alertCategory
            ioc_dict
            incidentType {
                metaDescription {
                    contentBody
                    assets
                }
            }
            alert_incidents {
                incidentId
                alertId
                incident {
                    displayId
                }
            }
        }
    }
`

export const FETCH_MULTIPLE_TASKS = gql`
    query FETCH_MULTIPLE_TASKS(
        $taskLabel: String!
        $status: String!
        $incident: incidents_incident_bool_exp!
    ) {
        tasks_task(
            where: {
                label: { _eq: $taskLabel }
                status: { _neq: $status }
                incident: $incident
            }
        ) {
            id
            incident {
                displayId
                id
            }
        }
    }
`

export const GET_LAST_FIVE_EVENTS = gql`
    query LAST_FIVE_EVENTS($alertId: String) {
        events: alerts_alertEvent(
            where: { alertId: { _eq: $alertId } }
            order_by: { alertTimestamp: desc }
            limit: 5
        ) {
            id
            agent_name
            alertTimestamp
            alert_tactic
            alert_technique
            asset {
                id
                label
                assetCriticality {
                    color
                    label
                }
            }
            alertCriticality {
                color
            }
            alert_level
            alert_criticality_label
            alertDescription
            isOpen
            status: alertDisposition {
                label
            }
        }
    }
`

export const GET_USER_ACTIVE_WORKROLE_COUNT = gql`
    query GET_USER_ACTIVE_WORKROLE_COUNT($userId: String!) {
        workRoles: users_user_workRole_aggregate(
            where: { userId: { _eq: $userId } }
        ) {
            aggregate {
                count
            }
        }
    }
`

export const GET_TASK_ARTIFACT_HISTORY_LOGS = gql`
    query GET_TASK_ARTIFACT_HISTORY_LOGS(
        $incidentId: String = ""
        $taskId: String = ""
        $artifactId: String = ""
    ) {
        taskArtifactHistory: history_artifacts(
            where: {
                incidentId: { _eq: $incidentId }
                taskId: { _eq: $taskId }
                artifactId: { _eq: $artifactId }
            }
            order_by: { createdAt: asc_nulls_first }
        ) {
            id
            newValues
            actionType
            updatedByUser {
                firstName
                lastName
            }
            createdAt
        }
    }
`

export const GET_THEIA_PROMPTS_FOR_SUBTASKS = gql`
    query GET_THEIA_PROMPTS_FOR_SUBTASKS($type: String = "") {
        prompts: master_theiaPrompts(where: { type: { _eq: $type } }) {
            id
            displayText
            type
        }
        promptHistories: master_theiaPromptHistory(
            where: { theiaPrompt: { type: { _eq: $type } } }
        ) {
            id
            entityId
            promptId
        }
    }
`

export const GET_THEIA_PROMPTS_FOR_ALERTS = gql`
    query GET_THEIA_PROMPTS_FOR_ALERTS(
        $type: String = ""
        $entityId: String = ""
    ) {
        prompts: master_theiaPrompts(where: { type: { _eq: $type } }) {
            id
            displayText
            type
            promptHistoryCount: theiaPromptHistories_aggregate(
                where: { entityId: { _eq: $entityId } }
            ) {
                aggregate {
                    count
                }
            }
        }
    }
`

export const GET_ASSET_IDS = gql`
    query GET_ASSET_IDS($assetsWhere: assets_asset_bool_exp!) {
        assets: assets_asset(where: $assetsWhere) {
            id
            label
            assetTypeLabel
            assetCriticalityLabel
        }
    }
`
export const GET_VULNERABILITIES = gql`
    query GET_VULNERABILITIES(
        $offset: Int! = 0
        $limit: Int! = 10
        $orderBy: [vulnerability_vulnerability_order_by!] = {
            created_at: desc_nulls_last
        }
        $vulnerabilities_where: vulnerability_vulnerability_bool_exp
    ) {
        vulnerabilities: vulnerability_vulnerability(
            limit: $limit
            offset: $offset
            where: $vulnerabilities_where
            order_by: $orderBy
        ) {
            id
            asset {
                label
                assetCriticalityLabel
                id
            }
            severity
            package
            references
            publishedOn
            cve
            cvss3
            status
            isOpen
            created_at
            updated_at
            updatedBy
        }
        vulnerabilityAggregate: vulnerability_vulnerability_aggregate(
            where: $vulnerabilities_where
        ) {
            aggregate {
                count
            }
        }
    }
`
export const GET_TOTAL_VULNERABILITIES_BY_SEVERITY = gql`
    query GET_TOTAL_VULNERABILITIES_BY_SEVERITY(
        $params: jsonb!
        $status: String!
    ) {
        totalVulnerabilities: vulnerability_vulnerability_aggregate(
            where: { status: { _eq: $status } }
        ) {
            aggregate {
                count
            }
        }
        vulnerabilitiesBySeverity: users_organization {
            getVulnerabilitySeverityByOrganization(args: { params: $params })
        }
    }
`

export const GET_VULNERABILITIES_BY_CVE = gql`
    query GET_VULNERABILITIES_BY_CVE($params: jsonb! = {}) {
        vulnerabilitiesByCve: users_organization {
            getVulnerabilityCveByOrganization(args: { params: $params })
        }
    }
`
export const GET_VULNERABILITIES_BY_ASSET = gql`
    query GET_VULNERABILITIES_BY_ASSET($params: jsonb! = {}) {
        vulnerabilitiesByAsset: users_organization {
            getVulnerabilityAssetByOrganization(args: { params: $params })
        }
    }
`

export const GET_VULNERABILITIES_BY_SYSTEM = gql`
    query GET_VULNERABILITIES_BY_SYSTEM($params: jsonb! = {}) {
        vulnerabilitiesBySystem: users_organization {
            getVulnerabilitySystemByOrganization(args: { params: $params })
        }
    }
`

export const GET_MONITORED_ASSET_COUNT = gql`
    query GET_MONITORED_ASSET_COUNT {
        monitoredAssets: assets_asset_aggregate(
            where: { is_monitored: { _eq: true } }
        ) {
            aggregate {
                count
            }
        }
    }
`
export const FETCH_RACI_RESPONSIBILITIES = gql`
    query FETCH_RACI_RESPONSIBILITIES {
        raciResponsibility: raci_responsibility(order_by: { created_at: asc }) {
            id
            label
            description
        }
    }
`
export const FETCH_RACI_MAPPED_ROLES = gql`
    query FETCH_RACI_MAPPED_ROLES {
        raciMappedResponsibility: raci_raciMapping {
            id
            raciRoleId
            raciUserId
            responsibilityId: resposibilityId
            raciRole {
                id
                label
                iconUrl
            }
        }
    }
`
export const FETCH_RACI_USERS = gql`
    query FETCH_RACI_USERS {
        raciUsers: raci_raciUser {
            id
            customUserLabel
            userId
            user {
                id
                firstName
                lastName
                attachments
            }
        }
    }
`
export const CHECK_RACI_USER_EXIST = gql`
    query CHECK_RACI_USER_EXIST($where: raci_raciUser_bool_exp!) {
        checkRaciUserExist: raci_raciUser(where: $where) {
            id
            customUserLabel
        }
    }
`
export const FETCH_USERS_DETAILS = gql`
    query FETCH_USERS_DETAILS {
        userDetails: users_user {
            id
            firstName
            lastName
        }
    }
`
export const FETCH_RACI_ROLES = gql`
    query FETCH_RACI_ROLES {
        raciRoles: raci_raciRole {
            id
            label
            iconUrl
            description
        }
    }
`

export const GET_INTEGRATION_LIST_WITH_CONFIG = gql`
    query GET_INTEGRATION_LIST_WITH_CONFIG {
        integrations: integrations_integration {
            configTemplate
            label
            id
        }
    }
`

export const GET_INTEGRATION_LIST_WITH_CONFIG_BY_PK = gql`
    query GET_INTEGRATION_LIST_WITH_CONFIG_BY_PK($id: String!) {
        integration: integrations_integration_by_pk(id: $id) {
            configTemplate
            label
            id
        }
    }
`

export const GET_INTEGRATION_WITH_CURRENT_CONFIG = gql`
    query GET_INTEGRATION_WITH_CURRENT_CONFIG($integrationId: String!) {
        org_integration: users_organization_integration(
            where: { integrationId: { _eq: $integrationId } }
        ) {
            integrationConfig
            integration {
                id
                label
                configTemplate
            }
        }
    }
`

export const GET_ORGANIZATION_INTEGRATIONS = gql`
    query GET_ORGANIZATION_INTEGRATIONS {
        integrations: users_organization_integration {
            id
            integrationConfig
            integration {
                label
                id
                iconUrl
            }
            lastEventSyncTimestamp
            created_at
            updated_at
            isActive
        }
    }
`

export const FETCH_INTEGRATIONS = gql`
    query FETCH_INTEGRATIONS {
        integrations: integrations_integration {
            id
            label
            iconUrl
            currentIntegrations: organization_integrations_aggregate {
                aggregate {
                    count
                }
            }
        }
    }
`
export const FETCH_TASKS_TASKBOARDS = gql`
    query FETCH_TASKS_TASKBOARDS($incidentId: String!) {
        taskBoardList: tasks_taskBoard(
            where: { incidentId: { _eq: $incidentId } }
        ) {
            id
            label
            stageIconUrl
        }
    }
`

export const GET_MARKETPLACE_PLAYBOOKS = gql`
    query GET_MARKETPLACE_PLAYBOOKS(
        $order_by: [incidents_incidentTypeMarketPlace_order_by!]
        $where: incidents_incidentTypeMarketPlace_bool_exp!
        $limit: Int
    ) {
        playbooks: incidents_incidentTypeMarketPlace(
            where: $where
            order_by: $order_by
            limit: $limit
        ) {
            id
            label
            metaDescription {
                contentBody
            }
            tags
            rating
            price
        }
    }
`

export const GET_MARKETPLACE_PLAYBOOK_BY_ID = gql`
    query GET_MARKETPLACE_PLAYBOOK_BY_ID($id: String!) {
        playbook: incidents_incidentTypeMarketPlace_by_pk(id: $id) {
            id
            label
            metaDescription {
                contentBody
            }
            tags
            rating
            price
            template
        }
        purchaseHistory: payments_invoice(
            where: {
                comment: { _eq: "PLAYBOOK_PURCHASE" }
                metaDetails: { _contains: { playbookId: $id } }
            }
        ) {
            metaDetails
        }
    }
`

export const GET_DATA_FOR_INCIDENT_TIMELINE = gql`
    query GET_DATA_FOR_INCIDENT_TIMELINE($incidentId: String! = "") {
        tasks: tasks_task(
            where: { status: { _eq: "Done" }, incidentId: { _eq: $incidentId } }
            order_by: { created_at: asc }
        ) {
            id
            label
            created_at
            updated_at
            resolvedAt
            status
            taskBoard {
                label
            }
            displayId
            incidentId
            taskAssignedTo {
                firstName
                attachments
                id
            }
        }
        incident: incidents_incident_by_pk(id: $incidentId) {
            occuredOn
            detectedBy
            resolvedAt
            created_at
            resolvedBy
            isResolved
            resolvedByUser {
                firstName
                lastName
            }
            taskBoards {
                label
                minmaxTimes: getTasksResolvedAtMinMax
            }
        }
        linked_alerts: alerts_alert_incident(
            where: { incidentId: { _eq: $incidentId } }
        ) {
            alert {
                id
                created_at
                alertTimestamp
                alertDescription
                alertSummary
                asset {
                    label
                    assetCriticalityLabel
                }
            }
        }
    }
`

// Keep in sync with GET_DATA_FOR_INCIDENT_TIMELINE (alerts fields removed for production)
export const GET_DATA_FOR_INCIDENT_TIMELINE_WITHOUT_ALERTS = gql`
    query GET_DATA_FOR_INCIDENT_TIMELINE_WITHOUT_ALERTS(
        $incidentId: String! = ""
    ) {
        tasks: tasks_task(
            where: { status: { _eq: "Done" }, incidentId: { _eq: $incidentId } }
            order_by: { created_at: asc }
        ) {
            id
            label
            created_at
            updated_at
            resolvedAt
            status
            taskBoard {
                label
            }
            displayId
            incidentId
            taskAssignedTo {
                firstName
                attachments
                id
            }
        }
        incident: incidents_incident_by_pk(id: $incidentId) {
            occuredOn
            detectedBy
            resolvedAt
            created_at
            resolvedBy
            isResolved
            resolvedByUser {
                firstName
                lastName
            }
            taskBoards {
                label
                minmaxTimes: getTasksResolvedAtMinMax
            }
        }
    }
`

export const GET_DATA_FOR_SIMULATION_TIMELINE = gql`
    query GET_DATA_FOR_SIMULATION_TIMELINE($incidentId: String! = "") {
        tasks: tasks_task(
            where: { status: { _eq: "Done" }, incidentId: { _eq: $incidentId } }
            order_by: { created_at: asc }
        ) {
            id
            label
            created_at
            updated_at
            resolvedAt
            status
            taskBoard {
                label
            }
            displayId
            incidentId
            taskAssignedTo {
                firstName
                attachments
                id
            }
        }
        incident: incidents_incident_by_pk(id: $incidentId) {
            occuredOn
            detectedBy
            resolvedAt
            created_at
            resolvedBy
            isResolved
            resolvedByUser {
                firstName
                lastName
            }
            taskBoards {
                label
                minmaxTimes: getTasksResolvedAtMinMax
            }
        }
        linked_alerts: alerts_alert_incident(
            where: { incidentId: { _eq: $incidentId } }
        ) {
            alert {
                id
                created_at
                alertTimestamp
                alertDescription
                alertSummary
                asset {
                    label
                    assetCriticalityLabel
                }
            }
        }
    }
`

// Keep in sync with GET_DATA_FOR_SIMULATION_TIMELINE (alerts fields removed for production)
export const GET_DATA_FOR_SIMULATION_TIMELINE_WITHOUT_ALERTS = gql`
    query GET_DATA_FOR_SIMULATION_TIMELINE_WITHOUT_ALERTS(
        $incidentId: String! = ""
    ) {
        tasks: tasks_task(
            where: { status: { _eq: "Done" }, incidentId: { _eq: $incidentId } }
            order_by: { created_at: asc }
        ) {
            id
            label
            created_at
            updated_at
            resolvedAt
            status
            taskBoard {
                label
            }
            displayId
            incidentId
            taskAssignedTo {
                firstName
                attachments
                id
            }
        }
        incident: incidents_incident_by_pk(id: $incidentId) {
            occuredOn
            detectedBy
            resolvedAt
            created_at
            resolvedBy
            isResolved
            resolvedByUser {
                firstName
                lastName
            }
            taskBoards {
                label
                minmaxTimes: getTasksResolvedAtMinMax
            }
        }
    }
`

export const ASSET_ALERT_STATS = gql`
    query ASSET_ALERT_STATS($agentName: String!) {
        stats: alerts_assetAlertStats(
            args: { params: { agentName: $agentName } }
        ) {
            data
        }
    }
`

export const GET_ALERT_HP_FOR_LINKED_INCIDENT_BY_ALERT_ID = gql`
    query GET_ALERT_HP_FOR_LINKED_INCIDENT_BY_ALERT_ID($alertIds: [String!]) {
        alerts_alert_hp(where: { id: { _in: $alertIds } }) {
            id
            agent_ip
            agent_name
            alertTimestamp
            full_log
            alert_tactic
            alert_technique
            asset {
                id
                label
                assetCriticality {
                    color
                    label
                    assets {
                        id
                    }
                }
            }
            alertCriticality {
                color
            }
            alert_level
            alert_criticality_label
            alert_source
            alertDescription
            potentialIncidentSeverity
            potentialIncidentType
            alertSummary
            dest_ip
            dest_port
            signature
            src_ip
            src_port
            alertCategory
        }
    }
`

export const GET_ALERT_IDS_LINKED_TO_INCIDENT = gql`
    query GET_ALERT_IDS_LINKED_TO_INCIDENT($incidentId: String!) {
        linkedAlertIds: alerts_alert_incident(
            where: { incidentId: { _eq: $incidentId } }
        ) {
            alertId
        }
    }
`

export const GET_ALERT_EVENT_HP = gql`
    query GET_ALERT_EVENT_HP(
        $limit: Int! = 10
        $eventsWhere: alerts_alert_event_hp_bool_exp
        $offset: Int! = 0
        $orderBy: [alerts_alert_event_hp_order_by!] = { alertTimestamp: desc }
        $hash: String! = ""
    ) {
        alert_events: alerts_alert_event_hp(
            where: $eventsWhere
            limit: $limit
            offset: $offset
            order_by: $orderBy
        ) {
            id
            agent_name
            alertTimestamp
            alert_tactic
            alert_technique
            asset {
                id
                label
                assetCriticality {
                    color
                    label
                }
            }
            alertCriticality {
                color
            }
            alert_level
            alert_criticality_label
            alertDescription
            additional_details
            alert_log
            full_log
            ioc_dict
        }
        # totalEvents: alerts_alert_event_continuous_aggregate_hourly_aggregate(
        #     where: { hash: { _eq: $hash } }
        # ) {
        #     aggregate {
        #         sum {
        #             count
        #         }
        #     }
        # }
        # totalEvents: alerts_alert_event_hp_aggregate(where: $eventsWhere) {
        #     aggregate {
        #         count
        #     }
        # }
    }
`

export const GET_ALERT_EVENT_HP_DETAILS = gql`
    query GET_ALERT_EVENT_HP_DETAILS(
        $id: String
        $alertTimestamp: timestamptz
    ) {
        alert_events: alerts_alert_event_hp(
            where: {
                id: { _eq: $id }
                alertTimestamp: { _gte: $alertTimestamp }
            }
            limit: 1
            order_by: { id: desc }
        ) {
            id
            agent_ip
            agent_name
            alertTimestamp
            alert_log
            alert_tactic
            alert_technique
            asset {
                id
                label
                agentName
                assetCriticality {
                    color
                    label
                }
            }
            alertCriticality {
                color
            }
            alert_level
            alert_criticality_label
            alert_source
            alertDescription
            potentialIncidentSeverity
            potentialIncidentImpact
            potentialIncidentUrgency
            potentialIncidentType
            potentialIncidentTypeId
            alertSummary
            dest_ip
            dest_port
            signature
            src_ip
            srcip
            srcport
            dest_ip
            dest_port
            dest_user
            src_port
            alertCategory
            ioc_dict
            additional_details
        }
    }
`

export const GET_ALERT_HP_DETAILS_ONE = gql`
    query GET_ALERT_HP_DETAILS_ONE($id: String!) {
        alerts_alert_hp(where: { id: { _eq: $id } }) {
            id
            agent_ip
            agent_name
            alertTimestamp
            # alert_log
            full_log
            alert_tactic
            alert_technique
            asset {
                id
                label
                assetCriticality {
                    color
                    label
                }
            }
            alertCriticality {
                color
            }
            alert_level
            alert_criticality_label
            alert_source
            alertDescription
            potentialIncidentSeverity
            potentialIncidentSeverity_rel {
                severity
            }
            potentialIncidentImpact
            potentialIncidentUrgency
            potentialIncidentType
            potentialIncidentTypeId
            alertSummary
            dest_ip
            dest_port
            signature
            src_ip
            src_port
            alertCategory
            ioc_dict
            additional_details
            incidentType {
                metaDescription {
                    contentBody
                    assets
                }
            }
            alert_incidents {
                incidentId
                alertId
                incident {
                    displayId
                }
            }
        }
    }
`

export const GET_USERS_FOR_MENTION = gql`
    query GET_USERS_FOR_MENTION {
        users_user {
            id
            email
            firstName
            lastName
        }
    }
`

export const GET_COMMENTS = gql`
    query GET_COMMENTS(
        $commentCategory: jsonb
        $orderDirection: order_by! = desc
        $repliesDirection: order_by! = desc
    ) {
        comments: comments_comment(
            order_by: { created_at: $orderDirection }
            where: {
                parentCommentId: { _is_null: true }
                commentCategory: { _contains: $commentCategory }
            }
        ) {
            id
            contentBody
            editorState
            html
            created_at
            updated_at
            commentCategory
            commentedByUser {
                id
                firstName
                lastName
                attachments
            }
            childComments(order_by: { created_at: $repliesDirection }) {
                id
                contentBody
                editorState
                html
                parentCommentId
                created_at
                updated_at
                commentedByUser {
                    id
                    firstName
                    lastName
                }
            }
        }
    }
`

export const GET_CONVERSTAION = gql`
    query GET_CONVERSTAION($entityId: String, $entityType: String) {
        conversations: theia_conversation(
            where: {
                entityId: { _eq: $entityId }
                entityType: { _eq: $entityType }
            }
        ) {
            id
        }
    }
`

export const GET_PROMPTS_FOR_ENHANCER = gql`
    query GET_PROMPTS_FOR_ENHANCER {
        prompts: master_theiaPrompts(
            where: { type: { _in: ["subTaskEnhance", "taskDescription"] } }
        ) {
            id
            type
            displayText
        }
    }
`

export const CHECK_LABELS_IN_USE_BY_ASSETS = gql`
    query CHECK_LABELS_IN_USE_BY_ASSETS(
        $labels: [String!]!
        $ids: [String!] = []
    ) {
        assets: assets_asset_aggregate(
            where: { label: { _in: $labels }, id: { _nin: $ids } }
        ) {
            aggregate {
                count
            }
        }
    }
`

/**
 * Get asset types which have no parents
 */
export const GET_ROOT_ASSET_TYPES_V2 = gql`
    query GET_ROOT_ASSET_TYPES_V2 {
        types: master_asset_type(
            where: { parentId: { _is_null: true } }
            order_by: { parentId: asc_nulls_first }
        ) {
            id
            label
            displayLabel
            parentId
            config
            dataConfig
            canBeMonitored
        }
    }
`

/**
 * Get all asset types
 */
export const GET_ASSET_TYPES_V2 = gql`
    query GET_ASSET_TYPES_V2 {
        types: master_asset_type {
            id
            label
            displayLabel
            parentId
            config
            dataConfig
            canBeMonitored
        }
    }
`

export const GET_CATEGORIES_AND_INJECTS = gql`
    query GET_CATEGORIES_AND_INJECTS($simulated_incidentId: String!) {
        totalInjects: injects_inject_aggregate(
            where: { incidentId: { _eq: $simulated_incidentId } }
        ) {
            aggregate {
                count
            }
        }
        categoryQuery: injects_category_aggregate {
            aggregate {
                count
            }
            nodes {
                id
                name
                injects(
                    where: {
                        _or: [{ incidentId: { _eq: $simulated_incidentId } }]
                    }
                ) {
                    id
                    title
                    description
                    impact
                    urgency
                    category {
                        id
                        name
                        imageUrl
                    }
                }
            }
        }
    }
`

export const GET_SIMULATION_SESSION = gql`
    query GET_SIMULATION_SESSION {
        sessions: simulation_simulation(
            order_by: { created_at: desc }
            limit: 1
        ) {
            id
            created_at
            updated_at
        }
    }
`

export const GET_INJECTS_FOR_SIMULATED_INCIDENT = gql`
    query GET_INJECTS_FOR_SIMULATED_INCIDENT($incidentId: String!) {
        injects: simulation_incident_inject(
            where: { incidentId: { _eq: $incidentId } }
        ) {
            impact
            urgency
            inject {
                id
                category {
                    id
                    name
                    imageUrl
                }
                title
                description
                impact
                urgency
            }
            created_at
        }
    }
`

export const GET_SIMULATION_ACTIVE_USERS = gql`
    query GET_SIMULATION_ACTIVE_USERS {
        activeUsers: simulation_activeUsers {
            userId
            lastPing
            user {
                attachments
                email
                firstName
                lastName
                workRoles {
                    workRole {
                        label
                    }
                }
            }
        }
    }
`

export const AVERAGE_ESTIMATED_BREACH_IMPACT = gql`
    query AVERAGE_ESTIMATED_BREACH_IMPACT {
        organizations: users_organization {
            getAverageEstimatedBreachImpact
        }
    }
`

export const GET_INCIDENT_PERFORMANCE_METRICS = gql`
    query GET_INCIDENT_PERFORMANCE_METRICS($params: jsonb!) {
        metrics: incidents_performance_metric_means(args: { params: $params }) {
            data
        }
    }
`

//FIXME: simulation performance metrics
export const GET_SIMULATED_INCIDENT_METRICS = gql`
    query GET_SIMULATED_INCIDENT_METRICS($params: jsonb!) {
        simulation_kpis: simulation_kpiMeans(args: { params: $params }) {
            data
        }
    }
`

export const GET_SIMULATION_REPORT_DATA = gql`
    query GET_SIMULATION_REPORT_DATA($incidentId: String!) {
        report_data: incidents_incident_by_pk(id: $incidentId) {
            displayId
            occuredOn
            resolvedAt
            type
            assets {
                asset {
                    id
                    label
                    assetCriticalityLabel
                }
            }
            simulationKpis {
                metric_name: kpiType
                value
            }
            simulation_evaluations {
                type
                content
            }
            simulationParticipation {
                actual_participants
                expected_participants
            }
            simulationParam {
                parameters
            }
        }
    }
`

export const GET_ORG_ALLOWED_FOR_SIMULATION = gql`
    query GET_ORG_ALLOWED_FOR_SIMULATION {
        orgs: simulation_allowed_organizations {
            organization_id
        }
    }
`

export const GET_PLAN_MODULES = gql`
    query GET_PLAN_MODULES($org_size_id: Int!) {
        master_plan_module(where: { org_size_id: { _eq: $org_size_id } }) {
            org_size_id
            org_size {
                sizeValue
            }
            name
            price_annual
            price_monthly
        }
    }
`

export const CHECK_EMAIL_IN_USE = gql`
    query CHECK_EMAIL_IN_USE($email: String!) {
        users: users_user_aggregate(where: { email: { _eq: $email } }) {
            aggregate {
                count
            }
        }
    }
`
